export class AvoidSetting {

  constructor(list) {
    this.dirtRoad = list.includes('unpaved')
    this.toll = list.includes('tollroad')
    this.tunnel = list.includes('tunnel')
    this.difficultTurns = list.includes('harshTurn')
  }

  toQueryParams() {
    const res = {}
    AvoidSetting.KEYS.forEach(key => {
      res[key] = this[key]
    })
    return res
  }
}

AvoidSetting.KEYS = ["dirtRoad", "toll", "tunnel", "difficultTurns"]
